import { DropdownOption } from "@components/dropdown/dropdown.types";
import { CountryCode } from "./residence-dropdown.types";

export const getDropdownOption = (countryCode: CountryCode, options: DropdownOption[]) =>
	options.find((option) => option.value === countryCode);
